import {SignUpSectionHeaderType} from "../../Types/SignUp/SignUpSectionType";
import {Button, ColourSolid} from "@twigsby/frontend-framework";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheckCircle} from "@fortawesome/pro-solid-svg-icons/faCheckCircle";

const SignUpSectionHeader = (props: SignUpSectionHeaderType) => {
    return (
        <div className={`sign-up-section-header mb-sm ${props.complete && !props.visible ? 'sign-up-section-header-complete' : ''}`}>
            {props.visible && (
                <h4 className={'m-0'}>{props.label}</h4>
            )}

            {props.complete && !props.visible && (
                <>
                    <div className={'flex-row align-center'}>
                        <div className={'mr-xs'}>
                            <FontAwesomeIcon icon={faCheckCircle} fixedWidth={true} size={'2x'} />
                        </div>
                        <div>
                            <h6 className={'fade m-0'}>{props.label}</h6>
                            <h3 className={'m-0'}>{props.completeLabel}</h3>
                        </div>
                    </div>
                    <Button title={'Edit'} onClick={props.editCallBack} colour={ColourSolid.Text} />
                </>
            )}
        </div>
    )
}

export default SignUpSectionHeader
